import { endOfDay, add, startOfDay } from 'date-fns';
import store from '@/store';
import { getContentTypeSessionsByPeriod } from './sessions';
import { sortArray } from './utils';

function getCustomerSessions (customer) {
  const { selectedDate } = store.getters;
  const { contentTypeAllSessions } = store.state;
  let allSessionsCustomer = [];
  const amplifyCustomerSessions = contentTypeAllSessions;

  const start = startOfDay(add(new Date(selectedDate), { months: -6 }));
  const end = endOfDay(add(new Date(selectedDate), { years: 1 }));

  const sessions = getContentTypeSessionsByPeriod(start, end, { ...customer, wtype: 'customer' }, amplifyCustomerSessions);
  allSessionsCustomer = sortArray(sessions, 'start_time', '>');
  allSessionsCustomer = allSessionsCustomer.map(s => ({
    ...s,
    isEditing: false
  }));

  return allSessionsCustomer;
}

export { getCustomerSessions };
